import globalStore from "@/store/global"
import ModelManagement from "@/components/model-management";
import BaseModal from "..";
import homeStore from '@/pages/home/store.js';

const ModelManagementModal = {
  show(data) {
    this.self = BaseModal.show({
      borderRadius: 24,
      content: (
        <ModelManagement
          {...data}
          onClose={this.close}
        />
      ),
      wrapClassName: 'nw-base-modal nw-base-modal-p-0',
      afterClose: () => {
        data?.afterClose?.();
        homeStore.updateModelList(true)
      },
    });
    this.id = globalStore.regModal(this);
  },
  close() {
    if (this.self) {
      this.self.destroy();
      this.self = null
    }
  }
}

export default ModelManagementModal
